/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 18:34:22
 * @LastEditors: xst
 * @LastEditTime: 2020-03-31 18:35:58
 */
import drag from "./drag";

const install = function(Vue) {
  Vue.directive("el-drag-dialog", drag);
};

if (window.Vue) {
  window["el-drag-dialog"] = drag;
  Vue.use(install); // eslint-disable-line
}

drag.install = install;
export default drag;



// WEBPACK FOOTER //
// ./src/el-dragDialog/index.js